import React from 'react'
import { IntegrationIcon } from '../../../../components/IntegrationIcon'
import { IntegrationServiceId } from '../../../../common/integrations'
import { CrossClientQueryDataSource } from '../../../../models/CrossClient'

interface CrossClientResultSourceIconProps {
  source: CrossClientQueryDataSource
}

export const CrossClientResultSourceIcon: React.FC<CrossClientResultSourceIconProps> = ({ source }) => {
  if (source.type === 'clientProfile') {
    return <i className='bi bi-person-lines-fill' />
  }

  if (source.type === 'integration') {
    return <IntegrationIcon serviceId={source.integrationType as IntegrationServiceId} width='0.75rem' height='0.75rem' />
  }

  return <i className='bi bi-question' />
}
